<h2 class="text-xl font-bold mt-2 mb-1">{{ '#PRODUCT_SCAN.FIND.TITLE' | translate }}</h2>

<section class="soft-section info-box mt-3">
  <span class="overline-list custom-color-tertiary mb-1">{{ '#PRODUCT_SCAN.FIND.GUIDE_TITLE' | translate }}</span>
  <div class="text-xs color-light">
    {{ '#PRODUCT_SCAN.FIND.GUIDE' | translate }}
  </div>
</section>

<div class="action-header mt-5 color-light font-medium">{{ '#PRODUCT_SCAN.FIND.MANUAL_INPUT' | translate }}</div>
<soft-input [placeholder]="'#PRODUCT_SCAN.FIND.MANUAL_PLACEHOLDER'" #input (valueChange)="manualInput$.next($event ?? '')"></soft-input>
<button class="soft-button primary w-full mt-2 min-height-button" [disabled]="(input?.value?.length ?? 0) < 2" (click)="findProduct(input?.value() || '')">
  @if (!(loading$ | async)) {
    <span class="pt-1">{{ '#PRODUCT_SCAN.FIND.BUTTON' | translate }}</span>
  } @else {
    <soft-loading-spinner class="small spin"></soft-loading-spinner>
  }
</button>

<div class="action-header  uppercase mt-4 color-light font-medium">{{ '#PRODUCT_SCAN.FIND.OR' | translate }}</div>
<div class="soft-card rounded border-primary flex flex-row flex-nowrap pb-4 pt-4 pr-4 pl-4 center-v mb-1" (click)="startScan()">
  <i class="fa-regular fa-barcode-scan fa-3x mr-2 ml-1"></i>
  <div class="flex flex-col justify-center ml-3">
    <span class="text-bold">{{ '#PRODUCT_SCAN.FIND.SCAN_HEADER' | translate }}</span>
    <span class="color-light">
      {{ '#PRODUCT_SCAN.FIND.SCAN_DESCRIPTION' | translate }}
    </span>
  </div>
</div>
